/** --------------------------------------------------
*
*   page video
*   PAGE VIDEO PLAYER
*
*  -------------------------------------------------- */

(function ($, Drupal, once, duo) {
  Drupal.behaviors.page_video_player = {

    attach: function (context, settings) {
      const self = this;

      $(once('page_video_player', 'html', context)).each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {
      const self = this;

      // loop through all the video blocks,
      // in case of vimeo, create the iframe:
      // -> vimeo videos need the iframe added when loading the page
      //    (to prevent autoplay-issues when using the custom play-button);
      // -> videos from other providers have their iframes added when clicking
      //    on the play button;
      const $videoBlocks = $(document).find('.js-page-video');
      $videoBlocks.each(function(index, element) {
        const $videoBlock = $(this);
        const videoSource = self.getVideoSource($videoBlock);
        if (videoSource === "vimeo") {
          self.addVideoEmbed($videoBlock);
        }
      });

      // observe all video player blocks
      // to toggle css classes based on the width of the video:
      if (window.ResizeObserver) {
        const $videoBlocks = $(document).find('.js-page-video');
        $videoBlocks.each(function(index, element) {
          const $videoBlock = $(this);
          const videoBlock = $videoBlock[0];

          const ro = new ResizeObserver(entries => {
            for (let entry of entries) {
              const itemWidth = entry.contentRect.width;
              if(itemWidth > 940) {
                $videoBlock.addClass('page-video--large');
              } else {
                $videoBlock.removeClass('page-video--large');
              }
            }
          });

          ro.observe(videoBlock);
        });
      }

      // when clicking a custom video play button:
      // -> in case of vimeo, use the vimeo sdk to start the video
      //    (the iframe is already on the page);
      // -> otherwise, get the video id and load a video embed iframe;
      $(document).on('click', '.js-page-video-play-button', function(e) {
        const $playButton = $(this);
        const $videoBlock = $playButton.parents('.js-page-video');

        if($playButton.hasClass('js-active')) {

          // do nothing when video is playing...

        } else {

          // check where the video is from:
          const videoSource = self.getVideoSource($videoBlock);

          // add classes:
          $playButton.addClass('js-active');
          $videoBlock.addClass('js-video-start');

          // use vimeo player sdk to start vimeo videos,
          // or add the video iframe for other providers;

          // vimeo:
          if (videoSource === "vimeo") {

            // first, check if the videoBlock has a video iframe,
            // if not, add it again;
            // (this may happen when something goes wrong with the interruption timeouts)
            if (videoSource === "vimeo") {
              const $videoBlockIframe = $videoBlock.find('iframe.video-iframe-embed');
              if($videoBlockIframe.length === 0) {
                self.addVideoEmbed($videoBlock);
              }
            }

            // vimeo api:
            if (typeof Vimeo !== "undefined") {
              let vimeoIframe = $videoBlock.find('iframe');
              let vimeoPlayer = new Vimeo.Player(vimeoIframe);

              // start video:
              let playPromise = vimeoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.then(_ => {
                  // video is playing ok
                })
                .catch(error => {
                  // video could not (auto)play
                });
              }
            }
          } else {
            // other providers;
            // add the video iframe:
            self.addVideoEmbed($videoBlock);
          }
        }
      });
    },

    addVideoEmbed: function($videoBlock) {
      const self = this;

      let videoEmbedId = null;
      let embedUri = '';

      // get the video source (vimeo or youtube), and
      // depending on the source, create the iframe embed url:
      const videoSource = self.getVideoSource($videoBlock);
      if (videoSource === "vimeo") {
        const vimeoEmbedBaseUri = "https://player.vimeo.com/video/";
        const vimeoEmbedPrefs = "?autoplay=0&autopause=0";
        videoEmbedId = $videoBlock[0].getAttribute('data-vimeoid');
        embedUri = vimeoEmbedBaseUri + videoEmbedId + vimeoEmbedPrefs;
      } else if (videoSource === "youtube") {
        const ytEmbedBaseUri = "https://www.youtube.com/embed/";
        const ytEmbedPrefs = "?rel=0&modestbranding=1&autohide=1&showinfo=0&disablekb=1&autoplay=1";
        videoEmbedId = $videoBlock[0].getAttribute('data-youtubeid');
        embedUri = ytEmbedBaseUri + videoEmbedId + ytEmbedPrefs;
      }

      const iframeEmbed = $('<iframe>', {
        src: embedUri,
        class: 'video-iframe-embed',
        frameborder: 0,
        scrolling: 'no',
        allow: 'autoplay',
        allowfullscreen: 'allowfullscreen'
      });
      iframeEmbed.appendTo($videoBlock);
    },

    getVideoSource: function($videoBlock) {
      let videoSource = "unknown";

      if ($videoBlock[0].hasAttribute('data-youtubeid')) {
       videoSource = "youtube";
      } else if ($videoBlock[0].hasAttribute('data-vimeoid')) {
        videoSource = "vimeo";
      }

      return videoSource;
    }
  };
})(jQuery, Drupal, once, window.duo = window.duo || {});
